module.exports = __webpack_public_path__ + "img/国家植物园.69899d35.png";